import { t } from "@travily/i18n";
import { EmptyState } from "@ui/components/EmptyState";
import { Icon } from "@ui/components/Icon";
import { Illustration } from "@ui/components/Illustration";
import { PromptButton } from "@ui/components/PromptButton";
import type { ReviewCardProps } from "./ReviewCard";
import { ReviewCard } from "./ReviewCard";

export interface ReviewsProps {
  onAddReview?: () => void;
  reviews: Array<ReviewCardProps & { id: number }>;
}

export function Reviews({ onAddReview, reviews }: ReviewsProps) {
  return (
    <div className="flex flex-col gap-3 lg:gap-5">
      {onAddReview && (
        <PromptButton
          description={t("components.views.products.reviews.add_review_hint")}
          icon={<Icon name="review" size="32" type="sticker" />}
          onPress={onAddReview}
        >
          {t("components.views.products.reviews.add_review")}
        </PromptButton>
      )}
      {reviews.length === 0 ? (
        <EmptyState
          description={t("components.views.products.reviews.empty_description")}
          illustration={<Illustration name="reviews" />}
          title={t("components.views.products.reviews.empty_title")}
        />
      ) : (
        reviews.map((review) => <ReviewCard key={review.id} {...review} />)
      )}
    </div>
  );
}
